import { Component, EventEmitter, OnInit } from '@angular/core';
import { ConfigurationHelper, IMapDetails } from 'src/app/core/static-classes/configuration-helper';
import { NearbyProjectTypeFilterEnum, MapParentView } from 'src/app/core/enums';
import { MapService } from 'src/app/core/map.service';
import { SettingsService } from 'src/app/core/settings.service';
import { LocalStorageHelper } from 'src/app/core/static-classes/local-storage-helper';
import { ViewEnum } from 'src/app/core/nav.service';
import { SubscriptionBaseComponent } from '../base-classes/subscription-base.component';
import { JsonHelper } from 'src/app/core/static-classes/json-helper';
import { STANDALONE_COMPONENT_IMPORTS } from '../standalone-component-imports';
import { MapTypeSelectorComponent } from '../map-type-selector/map-type-selector.component';

@Component({
    standalone: true,
    imports: [
        MapTypeSelectorComponent,
        ...STANDALONE_COMPONENT_IMPORTS,
    ],
    selector: 'pd-map-settings',
    templateUrl: './map-settings.component.html',
    styleUrls: [],
})
export class MapSettingsComponent extends SubscriptionBaseComponent implements OnInit {
    public active: boolean;
    public selectedMapDetails: IMapDetails;
    public nearbyProjectTypeFilter: NearbyProjectTypeFilterEnum;
    public viewEnum: ViewEnum;
    public subViewEnum: MapParentView;
    public tileChangeEmitter = new EventEmitter<void>();

    public NearbyProjectTypeFilterEnum = NearbyProjectTypeFilterEnum;
    public ViewEnum = ViewEnum;
    public PlantAssetsMapParentView = MapParentView;
    
    constructor(
        private readonly settingsService: SettingsService,
        private readonly mapService: MapService,
    ) {
        super();
    }

    ngOnInit(): void {
        this.sub = this.settingsService.active$.subscribe({
            next: (options) => {
                this.viewEnum = options.view;
                this.subViewEnum = options.subView;
                this.active = options.active;
            }
        });
        this.setCurrentValues();
    }

    public close(): void {
        this.setCurrentValues();
        this.active = false;
    }

    private setCurrentValues(): void {
        this.nearbyProjectTypeFilter = ConfigurationHelper.nearbyProjectTypeFilter;
        this.selectedMapDetails = JsonHelper.deepCopy(ConfigurationHelper.mapDetails);
    }

    public applySettings(): void {
        this.tileChangeEmitter.emit();
    }

    public mapTilesChanged(redrawMapNeeded: boolean): void {
        this.checkNearbyProjectFilterChanged();
        this.active = false;
        const mapDetailsChange = this.checkMapSettingsChanged();
        if (!redrawMapNeeded && mapDetailsChange) {
            // Emit map details change if map has not already been redrawn
            this.settingsService.mapSettingsChanged();
        }
    }

    private checkMapSettingsChanged(): boolean {
        const previousMapSettings = ConfigurationHelper.mapDetails;
        if (JSON.stringify(previousMapSettings) !== JSON.stringify(this.selectedMapDetails)) {
            ConfigurationHelper.mapDetails = JSON.parse(JSON.stringify(this.selectedMapDetails));
            LocalStorageHelper.setItem(LocalStorageHelper.SELECTED_MAP_DETAILS, this.selectedMapDetails);
            return true;
        }
        return false;
    }

    private checkNearbyProjectFilterChanged(): void {
        if (this.nearbyProjectTypeFilter !== ConfigurationHelper.nearbyProjectTypeFilter) {
            ConfigurationHelper.nearbyProjectTypeFilter = this.nearbyProjectTypeFilter;
            LocalStorageHelper.setItem(LocalStorageHelper.NEARBY_PROJECTS_FILTER, this.nearbyProjectTypeFilter);
            this.mapService.nearbyProjectTypeFilterChanged();
        }
    }

}
